import React, { FC } from 'react';
import { Switch, RouteComponentProps, Route } from 'react-router-dom';
import {
  SecondaryMenu,
  SecondaryMenuLink,
} from '../../../Shared/components/SecondaryMenu';
import { AnimatePresence } from 'framer-motion';
import urlJoin from 'url-join';
import styles from './styles.module.css';

import { useAuth0 } from '../../../Auth';

import { GrantsType, hasScopedPermission } from 'Shared/utils';
import { createPartnerPolicy } from 'Admin/authPolicies';
import { GET_PARTNER_BY_ID } from 'Admin/Partners/graphql';
import { Moratoriums } from 'Tools/Moratoriums';
import {
  MoratoriumDetails,
  RouteParams,
} from 'Tools/Moratoriums/MoratoriumDetails';
import { StateConfigurations } from 'Tools/StateConfigurations';
import { AnimatedRedirect } from 'Shared/components';

export const getRefetchPartnerQuery = (
  id: string | undefined,
  grants: GrantsType
) => ({
  query: GET_PARTNER_BY_ID,
  variables: {
    id,
    canViewPartnerChannelCommission: createPartnerPolicy(grants),
  },
});

export const Router: FC<RouteComponentProps> = ({ match }) => {
  const { user } = useAuth0();

  const hasManagePermission = hasScopedPermission(
    user?.effectiveGrants || [],
    'partner',
    'moratoriums.read'
  );

  const hasConfigurationsPermission = hasScopedPermission(
    user?.effectiveGrants || [],
    'partner',
    'state_configurations.read'
  );

  const defaultUrl = hasManagePermission
    ? urlJoin(match.url, '/moratoriums')
    : hasConfigurationsPermission
      ? urlJoin(match.url, '/state-configurations')
      : '/';

  return (
    <>
      <SecondaryMenu>
        {hasManagePermission && (
          <SecondaryMenuLink
            key="Moratoriums"
            item={{
              testId: 'moratoriums',
              name: 'Moratoriums',
              path: urlJoin(match.url, '/moratoriums'),
            }}
          />
        )}
        {hasConfigurationsPermission && (
          <SecondaryMenuLink
            key="StateConfigurations"
            item={{
              testId: 'state-configurations',
              name: 'State Configurations',
              path: urlJoin(match.url, '/state-configurations'),
            }}
          />
        )}
      </SecondaryMenu>
      <div className={styles.routeContainer}>
        <AnimatePresence mode="wait">
          <Switch>
            <Route
              exact
              path={urlJoin(match.url, '/moratoriums')}
              render={(props) => <Moratoriums {...props} />}
            />
            <Route
              path={urlJoin(match.url, '/moratoriums/:id')}
              render={(props) => (
                <MoratoriumDetails
                  {...(props as unknown as RouteComponentProps<RouteParams>)}
                />
              )}
            />
            <Route
              exact
              path={urlJoin(match.url, '/state-configurations')}
              render={(props) => <StateConfigurations {...props} />}
            />
            <AnimatedRedirect to={defaultUrl} from={match.url} />
          </Switch>
        </AnimatePresence>
      </div>
    </>
  );
};
